import { forwardRef } from 'react';

const Backdrop = forwardRef(({ backdrop, animated = false }, ref) => {
  if (!backdrop) {
    return null;
  }
  switch (backdrop.split('.').pop()) {
    case 'jpg':
    case 'jpeg':
    case 'png':
      return <div ref={ref} className="backdrop" style={{ backgroundImage: `url("${backdrop}")` }}></div>;
    case 'mp4':
    case 'm4v':
      return (
        <video
          ref={ref}
          className="backdrop backdrop--video"
          src={`${backdrop}#t=0.1`}
          autoPlay={!!animated}
          loop
          playsInline
          muted
        />
      );
    default:
      return null;
  }
});

export default Backdrop;
